import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../Style/MoleculeBuilder.css';
import moleculeRecipes from './moleculeRecipes'; // Importation des données

const elementsData = [
  { symbol: 'H', name: 'Hydrogen', number: 1 },
  { symbol: 'O', name: 'Oxygen', number: 8 },
  { symbol: 'C', name: 'Carbon', number: 6 },
  { symbol: 'Na', name: 'Sodium', number: 11 },
  { symbol: 'Cl', name: 'Chlorine', number: 17 },
  { symbol: 'N', name: 'Nitrogen', number: 7 },
  { symbol: 'P', name: 'Phosphorus', number: 15 }
];

const numbers = ['₁', '₂', '₃', '₄', '₅', '₆', '₇', '₈', '₉']; // Chiffres pour les indices

const MoleculeBuilder = () => {
  const [selectedElements, setSelectedElements] = useState([]);
  const [result, setResult] = useState(null);
  const [correctMolecule, setCorrectMolecule] = useState(null); // Nouvel état pour stocker la bonne molécule

  const handleElementClick = (element) => {
    setSelectedElements([...selectedElements, element.symbol]);
  };

  const handleNumberClick = (number) => {
    if (selectedElements.length > 0) {
      const updatedElements = [...selectedElements];
      updatedElements[updatedElements.length - 1] += number;
      setSelectedElements(updatedElements);
    }
  };

  const checkMolecule = () => {
    const formulaString = selectedElements.join('');
    const match = moleculeRecipes.find(
      (molecule) => molecule.formula.join('') === formulaString
    );
    if (match) {
      setResult(`Mélange valide : ${match.name}`);
      setCorrectMolecule(match); // Stocke la bonne molécule
    } else {
      setResult('Combinaison incorrecte.');
      setCorrectMolecule(null); // Réinitialise la bonne molécule en cas de mauvais résultat
    }
  };

  const resetSelection = () => {
    setSelectedElements([]);
    setResult(null);
    setCorrectMolecule(null); // Réinitialise la bonne molécule lorsqu'on réinitialise
  };

  return (
    <div>
      <h2>Construire une Molécule</h2>

      <motion.div
        className="element-list"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {elementsData.map((element) => (
          <motion.button
            key={element.number}
            className="element-button"
            whileHover={{ scale: 1.1, backgroundColor: '#f0f0f0' }}
            whileTap={{ scale: 0.9 }}
            onClick={() => handleElementClick(element)}
          >
            {element.symbol}
          </motion.button>
        ))}
      </motion.div>

      <motion.div
        className="number-list"
        initial={{ x: '-100vw' }}
        animate={{ x: 0 }}
        transition={{ type: 'spring', stiffness: 60 }}
      >
        {numbers.map((number, index) => (
          <motion.button
            key={index}
            className="number-button"
            whileHover={{ scale: 1.1, backgroundColor: '#d0f0d0' }}
            whileTap={{ scale: 0.9 }}
            onClick={() => handleNumberClick(number)}
          >
            {number}
          </motion.button>
        ))}
      </motion.div>

      <motion.div
        className="selected-elements"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <h3>Éléments Sélectionnés :</h3>
        {selectedElements.join('') || 'Aucun élément sélectionné'}
      </motion.div>

      <motion.button
        className="check-button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={checkMolecule}
      >
        Vérifier la molécule
      </motion.button>
      <motion.button
        className="reset-button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={resetSelection}
      >
        Réinitialiser
      </motion.button>

      {result && (
        <motion.div
          className="result"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {result}
        </motion.div>
      )}

      {correctMolecule && (
        <motion.div
          className="molecule-card"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 100 }}
        >
          <h4>{correctMolecule.name}</h4>
          <p>Formule : {correctMolecule.formula.join(' ')}</p>
          <p>{correctMolecule.description}</p>
        </motion.div>
      )}
    </div>
  );
};

export default MoleculeBuilder;
